import { call, put } from 'redux-saga/effects';

import generateQuery from 'utils/generateQuery';

import {
  axiosAuthInstance,
  API_END_POINTS,
} from 'api';
import { MESSAGES } from 'appconstants';

import {
  SCHEDULE_REPORTS,
  LOADING,
  NOTIFICATION,
} from '../actionTypes';

const fetchScheduleReports = async (payload) => {
  const query = generateQuery(payload.currentPage);
  const sorting = payload.sortParams ? payload.sortParams : '&sortBy=createdAt&direction=DESC';
  if (payload.filterParams && !payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.SCHEDULE_REPORTS}?${payload.filterParams}`);
  }
  if (payload.filterParams && payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.SCHEDULE_REPORTS}${query}${sorting}&${payload.filterParams}`);
  }
  if (!payload.filterParams && payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.SCHEDULE_REPORTS}${query}${sorting}`);
  }
  return axiosAuthInstance.get(`${API_END_POINTS.SCHEDULE_REPORTS}${query}${sorting}`);
};

const postScheduleReport = async ({ params }) => axiosAuthInstance.post(API_END_POINTS.SCHEDULE_REPORTS, params);

const deleteScheduleReport = async ({ gid }) => axiosAuthInstance.delete(`${API_END_POINTS.SCHEDULE_REPORTS}/${gid}`);

export function* getScheduleReports(action) {
  try {
    const { data: { entity } } = yield call(fetchScheduleReports, action.payload);
    yield put({ type: SCHEDULE_REPORTS.SUCCESS, payload: entity });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
    yield put({ type: SCHEDULE_REPORTS.FAILED, payload: e.response.data });
  }
}

export function* addScheduleReport(action) {
  try {
    yield put({ type: LOADING.SUBMITTING });
    yield put({ type: LOADING.VALIDATING });
    yield call(postScheduleReport, action.payload);
    const { data: { entity } } = yield call(fetchScheduleReports, action.payload);
    yield put({ type: SCHEDULE_REPORTS.SUCCESS, payload: entity });
    yield put({
      type: NOTIFICATION.SUCCESS,
      payload: MESSAGES.SCHEDULE_REPORTS.ADD_SUCCESS,
    });
    yield put({ type: LOADING.VALIDATED });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  } finally {
    yield put({ type: LOADING.SUBMITTED });
  }
}

export function* deleteScheduleReports(action) {
  try {
    yield put({ type: LOADING.VALIDATING });
    yield put({ type: LOADING.SUBMITTING });
    yield call(deleteScheduleReport, action.payload);
    const { data: { entity } } = yield call(fetchScheduleReports, action.payload);
    yield put({ type: SCHEDULE_REPORTS.SUCCESS, payload: entity });
    yield put({
      type: NOTIFICATION.SUCCESS,
      payload: MESSAGES.SCHEDULE_REPORTS.DELETE_SUCCESS,
    });
    yield put({ type: LOADING.VALIDATED });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  } finally {
    yield put({ type: LOADING.SUBMITTED });
  }
}
